var arncustom = {
  init: function() {
    this.settings = $('#arnSetings').length ? JSON.parse($('#arnSetings').html()) : {};
    let value = typeof jQuery.cookie !== 'undefined' ? $.cookie('popupUpsell') : typeof document.cookie !== 'undefined' ? this.getCookie("popupUpsell") : "";

    value = value ? value.split(',') : [];
    this.arrayUpsell = [...value];

    if (this.settings.page_type != 'cart') return;
    let this2 = this;
    setTimeout(() => {
      this2.callUpsell();
    }, 2000);
  },
  callUpsell: function() {
    const this2 = this;
    const templateID = this.settings.upsell_id;
    const template = document.getElementById(templateID);
    let show = false;
    if (!template) return;
    if (!template.content.firstElementChild.querySelectorAll('.product__details').length) return;
    template.replaceWith(template.content.firstElementChild);

    const productContainer = document.querySelector('#shopify-block-cart-popup');
    const activeHash = productContainer.querySelector('.active[data-quickshop-hash]').dataset.quickshopHash;
    if (!this.arrayUpsell.length) {
      this.arrayUpsell.push(activeHash);
      show = true;
    } else {
      productContainer.querySelectorAll('[data-quickshop-hash]').forEach(item => {
        let value = item.dataset.quickshopHash;
        if (!this2.arrayUpsell.includes(value) && !show) {
          productContainer.querySelectorAll('.active[data-quickshop-hash]').forEach(i => i.classList.remove('active'));
          productContainer.querySelector(`[data-quickshop-hash="${value}"]`).classList.add('active');
          this2.arrayUpsell.push(value);
          show = true;
        }
      })
    }

    setTimeout(() => {
      if (typeof $.cookie !== 'undefined' || typeof jQuery.cookie !== 'undefined' || typeof document.cookie !== 'undefined' ) {
        show && (document.getElementById('upsellPopup').style.display = 'flex'), show && document.body.classList.add('blocked-overflow');
        if(typeof $.cookie !== 'undefined' || typeof jQuery.cookie !== 'undefined'){
          $?.cookie('popupUpsell', this2.arrayUpsell.join(','));
        } else if(typeof document.cookie !== 'undefined'){
          this2.setCookie("popupUpsell", this2.arrayUpsell.join(','));
        }
      }
    }, 2000);

    show && $(document)
      .on('click', '.upsell-trigger-close', function(e) {
        document.body.classList.remove('blocked-overflow')
        e.target.closest('#shopify-block-cart-popup').remove();
      })
  },
  setCookie: function (cname, cvalue) {
    document.cookie = cname + "=" + cvalue + ";" + "Session" + ";path=/";
  },
  getCookie: function (cname) {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
}
$(document).ready(function() {
  arncustom.init();
})